import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { BiPaletteSwatch } from '@euler/app/flows/bi-dashboards/components/ui/BiPaletteSwatch';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette, kBiPaletteNames } from '@euler/model/bi/viz';
import { memo } from 'react';
import { Pressable } from 'react-native';

/** One palette to pick: its name and its colors. */
export const PaletteChip = memo(
  ({
    palette,
    selected,
    onPress,
  }: {
    palette: BiPalette;
    selected: boolean;
    onPress: (palette: BiPalette) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={`配色 ${kBiPaletteNames[palette]}`}
        accessibilityState={{ selected }}
        onPress={() => onPress(palette)}
        style={({ pressed }) => ({
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(6),
          paddingHorizontal: rpx(10),
          paddingVertical: rpx(6),
          borderRadius: rpx(16),
          borderWidth: 1,
          borderColor: selected ? aiColors.primary : aiColors.border,
          backgroundColor: selected
            ? tint(aiColors.primary, 0.08)
            : aiColors.card,
          opacity: pressed ? 0.75 : 1,
        })}
      >
        <Typography.Text
          family={selected ? 'medium' : 'regular'}
          size={rpx(12)}
          color={selected ? aiColors.primary : aiColors.foreground}
        >
          {kBiPaletteNames[palette]}
        </Typography.Text>
        <BiPaletteSwatch palette={palette} size={7} />
      </Pressable>
    );
  },
);
